<template>
  <v-container>
    <h3 class="mt-4">Import / Export</h3>
    <v-row class="mt-2">
      <v-col>
        <v-btn
          :to="{ name: 'Import Files (Beta)' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Import Files</v-btn>
      </v-col>
      <v-col>
        <v-btn
          :to="{ name: 'Transform Mapper (beta)' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Profile Config</v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-btn
          :to="{ name: 'Export Files (beta)' }"
          color="primary"
          rounded
        >Export Files</v-btn>
      </v-col>
      <v-col>
        <v-btn
          :to="{ name: 'Import Large Files' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Import Large Files</v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-btn :to="{ name: 'Database Backups' }" color="primary" rounded :disabled="isAuditorOnly"
          >Database Backup / Restore</v-btn>
      </v-col>
      <v-col>
        <v-btn :to="{ name: 'Cron Jobs' }" color="primary" rounded :disabled="isAuditorOnly"
          >Cron Jobs</v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-btn
          :to="{ name: 'Data Sync to Public' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Data Sync to Public</v-btn>
      </v-col>
      <v-col>
        <v-btn
          :to="{ name: 'Data Browser' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Data Browser</v-btn>
      </v-col>
      <v-col>
        <v-btn
          :to="{ name: 'Additional Scripts' }"
          color="primary"
          rounded
          :disabled="isAuditorOnly"
        >Additional Scripts</v-btn>
      </v-col>

      <!--v-col>
        <v-btn :to="{ name: 'Transform Files' }" color="primary" rounded hidden
          >Transform / Debug Files</v-btn>
      </v-col-->
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('auth/token', ['isAuditorOnly']),
  },
};
</script>
